import { render, staticRenderFns } from "./shippingFeeReimbursementStatement.vue?vue&type=template&id=ff287e36&scoped=true&"
import script from "./shippingFeeReimbursementStatement.vue?vue&type=script&lang=js&"
export * from "./shippingFeeReimbursementStatement.vue?vue&type=script&lang=js&"
import style0 from "./shippingFeeReimbursementStatement.vue?vue&type=style&index=0&id=ff287e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff287e36",
  null
  
)

export default component.exports